package org.catharsis.TVTally.theme

import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color

// Light Theme Colors
val DarkGrayPrimary = Color(0xFF4A4A4A)
val LightGrayButton = Color(0xFFB0B0B0)
val LightBackground = Color(0xFFF8F8F8)
val LightSurface = Color(0xFFFFFFFF)
val LightTextColor = Color(0xFF333333)

// Dark Theme Colors
val WhitePrimary = Color(0xFFFFFFFF)
val DarkGrayButton = Color(0xFF4A4A4A)
val DarkBackground = Color(0xFF1C1C1C)
val DarkSurface = Color(0xFF2A2A2A)
val DarkTextColor = Color(0xFFE0E0E0)

//App Specific
val deepGreen = Color(0xFF009975)
val Black = Color(0xFF000000)
val platinum = Color(0xFFDFE0E2)

val navy = Color(0xFF1B2A4A)

internal val LightColorScheme = lightColorScheme(
    primaryContainer = deepGreen,
    background = WhitePrimary,
    primary = Black,
    surface = LightSurface,
    onSurface = DarkGrayPrimary,
    secondary = WhitePrimary,
    onSecondary = LightTextColor,
    secondaryContainer = platinum,
)

internal val DarkColorScheme = darkColorScheme(
    primaryContainer = deepGreen,
    primary = WhitePrimary,
    background = DarkBackground,
    onBackground = DarkTextColor,
    surface = DarkSurface,
    onSurface = WhitePrimary,
    secondary = Black,
    onSecondary = DarkTextColor,
    secondaryContainer = DarkBackground
)